// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__25R_L","content":"RecentSearches_content__1KIZQ"};